/**
 * TanStack Query mutation hook for the SubContractorHub backfill preview
 * (Story SCH-3.1).
 *
 * Preview is one-shot per click — there's no cache to keep warm and no
 * point auto-refetching, since admins re-run the preview after fixing
 * mappings. So this is a `useMutation`, NOT a `useQuery`.
 *
 * The mutation returns the discriminated union from
 * `backfillPreviewService.runBackfillPreview` directly; consumers branch
 * on `result.error` to render the right modal state (auth_failed banner,
 * sch_unreachable explainer, success cards, etc.).
 */

import { useMutation } from '@tanstack/react-query';
import { backfillPreviewService } from '@/services/integrations/backfillPreviewService';

export function useBackfillPreview() {
  return useMutation({
    mutationFn: (options?: { search?: string }) =>
      backfillPreviewService.runBackfillPreview(options),
    // No retries — the backend has its own retry budget (5 retries on the
    // standard transport), and a frontend retry would silently double the
    // worst-case latency the admin sees.
    retry: false,
  });
}
